import { AxiosResponse } from 'axios';

import resolveV2 from '@/endpoints/resolverV2';

import { ILayer } from '../../../models/cdl';
import { AcresFeature } from '../../../models/features';

interface IResponse extends AxiosResponse {
  data: ILayer;
}

interface IResolvedCDLImage {
  res: IResponse | null;
  err: Error | null;
}

interface IData {
  year: string;
  boundary: AcresFeature;
}

export default function getCDLImage(data: IData): Promise<IResolvedCDLImage> {
  return resolveV2(
    {
      data,
      method: 'POST',
      url: '/geoserver/cdl_image',
    },
    {
      baseUrl: 'geoserver',
    }
  );
}
